import { Amenity, IAmenity } from "./amenity.model";
import { HouseFlat, IHouseFlat } from "./house-flat.model";
import { IStreetBuilding, StreetBuilding } from "./street-building.model";

export interface ICreatedBy {
  uid: string;
  names: string;
  paternalLastName: string;
  maternalLastName: string;
}

export class CreatedBy {
  uid: string;
  names: string;
  paternalLastName: string;
  maternalLastName: string;

  constructor(data: ICreatedBy) {
    this.uid = data.uid;
    this.names = data.names;
    this.paternalLastName = data.paternalLastName;
    this.maternalLastName = data.maternalLastName;
  }

  get fullName(): string {

    return [
      this.names,
      this.paternalLastName,
      this.maternalLastName
    ].filter(
      namePart => namePart.length > 0
    ).join(' ');
  }

}

export interface IBooking {
  bookingId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  amenityId: string;
  timetableId: string;
  startDate: string;
  endDate: string;
  weekday: number;
  guests: number;
  isBlocked: boolean;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  streetBuilding?: IStreetBuilding;
  houseFlat?: IHouseFlat;
  amenity?: IAmenity;
  createdBy?: ICreatedBy;
}

export class Booking {
  bookingId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  amenityId: string;
  timetableId: string;
  startDate: string;
  endDate: string;
  weekday: number;
  guests: number;
  isBlocked: boolean;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  streetBuilding?: StreetBuilding;
  houseFlat?: HouseFlat;
  amenity?: Amenity;
  createdBy?: CreatedBy;

  constructor(data: IBooking) {
    this.bookingId = data.bookingId;
    this.neighborhoodId = data.neighborhoodId;
    this.streetBuildingId = data.streetBuildingId;
    this.houseFlatId = data.houseFlatId;
    this.amenityId = data.amenityId;
    this.timetableId = data.timetableId;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.weekday = data.weekday;
    this.guests = data.guests;
    this.isBlocked = data.isBlocked;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.streetBuilding = data.streetBuilding
      ? new StreetBuilding(data.streetBuilding)
      : undefined;
    this.houseFlat = data.houseFlat
      ? new HouseFlat(data.houseFlat)
      : undefined;
    this.amenity = data.amenity
      ? new Amenity(data.amenity)
      : undefined;
    this.createdBy = data.createdBy
      ? new CreatedBy(data.createdBy)
      : undefined;
  }

  cancelEnabled(
    timeZone: number
  ): boolean {

    let flag = true;
  
    if (!this.status) {
      flag = false;
  
    } else {
      const timeZoneOffset = timeZone;
      const now = new Date();
      const bookingStart = new Date(this.startDate);
      bookingStart.setHours(bookingStart.getHours() + timeZoneOffset);
  
      const diffInHours = (bookingStart.getTime() - now.getTime()) / (1000 * 60 * 60);
  
      if (diffInHours < 0) {
        flag = false;
      }
    }
  
    return flag;
  }
  
}
